import { render, staticRenderFns } from "./CheckoutPayment.vue?vue&type=template&id=55133c98&"
import script from "./CheckoutPayment.vue?vue&type=script&lang=js&"
export * from "./CheckoutPayment.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutPayment.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports